import { modalSlice } from './slice';

export const { openModal, closeModal } = modalSlice.actions;
